import { useState } from "react";
import { Instagram, Plus } from "lucide-react";
import { REELS } from "@/data/content";
import { INSTAGRAM } from "@/lib/shop";
import { Reveal, Eyebrow } from "./Reveal";

const Reel = ({ url, i }) => (
  <div data-testid={`video-card-reaction-${i + 1}`} className="relative shrink-0 w-[82%] sm:w-auto snap-start rounded-[24px] overflow-hidden border border-[#1B1530]/10 bg-white h-[600px]">
    <iframe title={`First bite reaction ${i + 1}`} src={`${url}embed/`} loading="lazy" scrolling="no"
      className="absolute inset-0 w-full h-full" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
  </div>
);

export const Reactions = () => {
  const [shown, setShown] = useState(4);
  return (
    <section data-testid="instagram-video-grid" className="pb-24 lg:pb-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-10">
          <div>
            <Eyebrow className="text-[#FF5A5F] mb-4">{REELS.length} first-bite reactions</Eyebrow>
            <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">Real people. First taste.</h2>
          </div>
          <a data-testid="instagram-follow-link" href={INSTAGRAM} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 h-12 px-6 rounded-full border-2 border-[#1B1530] font-bold hover:bg-[#1B1530] hover:text-white transition-colors">
            <Instagram className="h-4 w-4" /> Follow on Instagram
          </a>
        </Reveal>
        <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-4 overflow-x-auto sm:overflow-visible snap-x snap-mandatory pb-2 -mx-4 px-4 sm:mx-0 sm:px-0">
          {REELS.slice(0, shown).map((u, i) => <Reel key={u} url={u} i={i} />)}
        </div>
        {shown < REELS.length && (
          <div className="mt-8 text-center">
            <button data-testid="reactions-load-more" onClick={() => setShown((s) => s + 4)}
              className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-[#1B1530] text-white font-bold hover:bg-[#FF5A5F] transition-colors">
              <Plus className="h-4 w-4" /> More reactions ({REELS.length - shown})
            </button>
          </div>
        )}
      </div>
    </section>
  );
};
